// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MU0L","newExpiryDate":"styles_newExpiryDate__1ocPM","footer":"styles_footer__37Zif"};